import { RegItemMinimal, RegItemType } from 'src/types/regItem'

export const useGetHandleRegItemClick = (regItem: RegItemMinimal) => {
  const regItemType: RegItemType | undefined = regItem.itemType

  switch (regItemType) {
    case 'cash_fund':
      return () => undefined
    case 'electronic_gift_card':
      return () => undefined
    case 'external_registry':
      return handleExternalRegistryClick(regItem)
    case 'favor':
      return () => undefined
    case 'group_gift':
      return () => undefined
    case 'product':
      return () => undefined
    default:
      return () => undefined
  }
}

const handleExternalRegistryClick = (regItem: RegItemMinimal) => () => {
  if (typeof window === 'undefined') return

  const offerUrl = regItem.offers?.[0]?.url

  if (offerUrl && offerUrl !== '') {
    window.open(offerUrl, '_blank')
  }
}
